// extracted by mini-css-extract-plugin
module.exports = {"pointer":"Pointer_pointer__1cpdW","horizontalPointer":"Pointer_horizontalPointer__2oT6V","verticalPointer":"Pointer_verticalPointer__3XQr0"};